var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('nav-bars'),_c('transition',{attrs:{"name":"fade"}},[_c('v-main',{staticClass:"background"},[_c('router-view')],1)],1),_c('v-overlay',{attrs:{"value":_vm.loading}}),_c('snackbar'),_c('login-dialog')],1)}
var staticRenderFns = []

export { render, staticRenderFns }